import React from 'react';
import './DeviceSelector.css';

const DeviceSelector = ({
  index,
  deviceType,
  quantity,
  devices,
  onDeviceChange,
  onQuantityChange,
  onRemove,
  canRemove
}) => {
  const handleDeviceSelect = (e) => {
    onDeviceChange(index, e.target.value);
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1) {
      onQuantityChange(index, value);
    }
  };

  const handleIncrement = () => {
    onQuantityChange(index, quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      onQuantityChange(index, quantity - 1);
    }
  };

  return (
    <div className="device-selector">
      <div className="selector-header">
         <span className="position-label">Позиция {index + 1}</span>
        {canRemove && (
          <button 
            onClick={() => onRemove(index)} 
            className="remove-button"
            type="button"
          >
            Удалить
          </button>
        )}
      </div>

      <div className="selector-controls">
        <div className="device-select">
           <label htmlFor={`device-${index}`}>Тип устройства:</label>
          <select
            id={`device-${index}`}
            value={deviceType}
            onChange={handleDeviceSelect}
            className="device-dropdown"
          >
            <option value="">Выберите устройство</option>
            {devices.map((device) => (
              <option key={device} value={device}>
                {device}
              </option>
            ))}
          </select>
        </div>

        <div className="quantity-control">
           <label htmlFor={`quantity-${index}`}>Количество:</label>
          <div className="quantity-input-group">
            <button 
              onClick={handleDecrement} 
              className="quantity-btn decrement"
              type="button"
              disabled={quantity <= 1}
            >
              −
            </button>
            <input
              id={`quantity-${index}`}
              type="number"
              min="1"
              value={quantity}
              onChange={handleQuantityChange}
              className="quantity-input"
            />
            <button 
              onClick={handleIncrement} 
              className="quantity-btn increment"
              type="button"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceSelector;